import { useContext } from 'react';
import { LogisticPartyDetails } from '../interfaces/LogisticPartyDetails.interface';
import LPContext from '../context/LPContext';

/**
 * Selects and returns the LPDetails from context
 * @returns LogisticPartyDetailsList
 */
function useLogisticParties(): LogisticPartyDetails[] {
  const logisticParties = useContext(LPContext);

  return logisticParties.lps;
}

export default useLogisticParties;
